// following tutorial by Brian Design
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import logo from "./anirudh-eagle.png";
import "./Navbar.css";

function Navbar() {
  const [click, setClick] = useState(false);
  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  useEffect(() => {
    const windowShrinker = () => {
      // This function can be used for responsive behavior if needed
      // Currently not being used, but kept for potential future use
    };

    window.addEventListener("resize", windowShrinker);
    
    // Cleanup function to remove event listener
    return () => {
      window.removeEventListener("resize", windowShrinker);
    };
  }, []);

  return (
    <>
      <nav className="navbar">
        <div className="navbar-container">
          <Link to="/" className="navbar-logo" onClick={closeMobileMenu}>
            <img src={logo} height="20" alt="Anirudh Chamarthi"/> Anirudh Chamarthi
          </Link>
          <div className="menu-icon" onClick={handleClick}>
            <i className={click ? "fa-solid fa-dragon" : "fas fa-bars"} />
            </div>
            <div>
            <ul className={click ? "nav-menu active" : "nav-menu"}>
              <li className="nav-item">
                <Link to="/projects" className="nav-links" onClick={closeMobileMenu}>Projects</Link>
              </li>
              <li className="nav-item">
                <Link to="https://github.com/AnirudhChamarthi" className="nav-links" onClick={closeMobileMenu}>GitHub</Link>
              </li>
              <li className="nav-item">
                <Link to="https://www.linkedin.com/in/anirudh-chamarthi-a0b40b201/" className="nav-links" onClick={closeMobileMenu}>LinkedIn</Link>
              </li>
              <li className = "nav-item">
                <Link to="/contact" className = "nav-links" onClick = {closeMobileMenu}>Contact</Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  )
}

export default Navbar;